












































































































































































import _ from "lodash";
import moment from "moment";
import Modal from "../core/Modals/Modal.vue";
import DateInput from "../core/Forms/DateInput.vue";
import PhotoUploader from "../core/Forms/PhotoUploader.vue";
import MaterielCategorieSelect from "../core/Forms/MaterielCategorieSelect.vue";
import MaterielEmplacementSelect from "../core/Forms/MaterielEmplacementSelect.vue";
import { MaterielApi } from "../api/MaterielApi";
import {
    EquipementMateriel,
    ETATS_OPERATIONNELS,
    FREQUENCES_ENTRETIEN,
} from "../models/Materiel";

export default {
    name: "EquipementEditModal",
    components: {
        Modal,
        DateInput,
        PhotoUploader,
        MaterielCategorieSelect,
        MaterielEmplacementSelect,
    },
    props: {
        showModal: Boolean,
        equipement: Object,
    },
    data() {
        return {
            MaterielApi: new MaterielApi(),
            form: new EquipementMateriel(),
            photoPath: null,
            frequenceMode: "",
            saving: false,
            etats: ETATS_OPERATIONNELS,
            frequences: FREQUENCES_ENTRETIEN,
        };
    },
    computed: {
        isEdit: function () {
            return !!this.form.id;
        },
    },
    methods: {
        reset: function () {
            let source = this.equipement
                ? this.equipement
                : new EquipementMateriel();
            this.form = new EquipementMateriel(source);
            this.photoPath =
                source.photo && source.photo.path ? source.photo.path : null;

            let frequence = this.form.frequence_entretien_jours;
            if (!frequence) {
                this.frequenceMode = "";
            } else if (FREQUENCES_ENTRETIEN.indexOf(frequence) !== -1) {
                this.frequenceMode = String(frequence);
            } else {
                this.frequenceMode = "custom";
            }
        },
        onCategorieChange: function (option) {
            let self = this;
            let ancienne = self.form.categorie_id;
            self.form.categorie_id = option ? option.id : null;

            // Sur un nouvel équipement, on propose le prochain numéro libre
            // de la catégorie choisie.
            if (
                !self.form.id &&
                self.form.categorie_id &&
                self.form.categorie_id !== ancienne
            ) {
                self.MaterielApi.getNextNumero(self.form.categorie_id)
                    .then(function (numero) {
                        self.form.numero = numero;
                    })
                    .catch(function (error) {
                        self.emitError(error);
                    });
            }
        },
        onEmplacementChange: function (option) {
            this.form.emplacement_id = option ? option.id : null;
        },
        setDateAchat: function (value) {
            this.form.date_achat = this.toSqlDate(value, this.form.date_achat);
        },
        setDateMiseEnService: function (value) {
            this.form.date_mise_en_service = this.toSqlDate(
                value,
                this.form.date_mise_en_service
            );
        },
        setFinGarantie: function (value) {
            this.form.fin_garantie = this.toSqlDate(
                value,
                this.form.fin_garantie
            );
        },
        toSqlDate: function (value, courant) {
            let date = moment(value, "DD/MM/YYYY", true);
            if (date.isValid()) {
                return date.format("YYYY-MM-DD");
            }
            if (!value) {
                return null;
            }
            return courant;
        },
        onFrequenceChange: function () {
            if (this.frequenceMode === "") {
                this.form.frequence_entretien_jours = null;
            } else if (this.frequenceMode !== "custom") {
                this.form.frequence_entretien_jours = parseInt(
                    this.frequenceMode,
                    10
                );
            }
        },
        onPhotoUploaded: function (photo) {
            this.form.photo_id = photo.id;
            this.photoPath = photo.path;
        },
        onUploadError: function (message) {
            this.$emit("toast", { message: message, kind: "error" });
        },
        removePhoto: function () {
            this.form.photo_id = null;
            this.photoPath = null;
        },
        save: function () {
            let self = this;

            if (!self.form.categorie_id) {
                self.$emit("toast", {
                    message: "Catégorie requise",
                    kind: "error",
                });
                return;
            }
            if (!self.form.emplacement_id) {
                self.$emit("toast", {
                    message: "Emplacement requis",
                    kind: "error",
                });
                return;
            }

            let creation = !self.form.id;
            self.saving = true;
            self.MaterielApi.saveEquipement(self.form)
                .then(function (saved) {
                    self.saving = false;
                    self.$emit("toast", {
                        message: creation
                            ? "Équipement ajouté"
                            : "Équipement modifié",
                        kind: "success",
                    });
                    self.$emit("saved", saved);
                })
                .catch(function (error) {
                    self.saving = false;
                    self.emitError(error);
                });
        },
        toggleArchive: function () {
            let self = this;
            if (!self.form.id) {
                return;
            }

            let desarchiver = !!self.form.archived;
            let titre = desarchiver
                ? "Désarchiver " + self.form.libelle + " ?"
                : "Archiver " +
                  self.form.libelle +
                  " ? Il sera masqué des listes mais son historique sera conservé.";

            swal({
                title: titre,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success",
                confirmButtonText: "Oui",
                cancelButtonClass: "btn btn-default",
                cancelButtonText: "Non",
                buttonsStyling: false,
            })
                .then(function () {
                    let request = desarchiver
                        ? self.MaterielApi.unarchiveEquipement(self.form.id)
                        : self.MaterielApi.archiveEquipement(self.form.id);

                    return request
                        .then(function (saved) {
                            self.$emit("toast", {
                                message: desarchiver
                                    ? "✓ Désarchivé"
                                    : "📦 Archivé",
                                kind: "success",
                            });
                            self.$emit("saved", saved);
                        })
                        .catch(function (error) {
                            self.emitError(error);
                        });
                })
                .catch(function () {});
        },
        emitError: function (error) {
            this.$emit("toast", {
                message: _.get(
                    error,
                    "response.data.message",
                    "Une erreur est survenue"
                ),
                kind: "error",
            });
        },
        close: function () {
            this.$emit("close-modal");
        },
    },
    watch: {
        showModal: {
            immediate: true,
            handler: function (value) {
                if (value) {
                    this.reset();
                }
            },
        },
        equipement: function () {
            if (this.showModal) {
                this.reset();
            }
        },
    },
};
